// React

// Material UI
import { TextField, InputAdornment } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

// Icons
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import { setDescription } from '../../../../../../../store/suggestEventSlice';

const DescriptionField = () => {
  const theme = createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          inputMultiline: {
            cursor: 'pointer',
            padding: '11px 13px',
            borderRadius: '8px',
            marginLeft: '18px',
            border: '1px solid #E8EBED',
            '&:hover': { border: '1px solid #98A6AE' },
            '@media (max-width:940px)': { marginLeft: '0px !important', marginRight: '15px' },
          },
        },
      },
      MuiInput: {
        defaultProps: { disableUnderline: true },
      },
    },
  });

  const description = useSelector((state) => state.suggestEvent.description);
  const dispatch = useDispatch();

  return (
    <ThemeProvider theme={theme}>
      <TextField
        variant="standard"
        placeholder="Add description"
        multiline
        minRows={2}
        maxRows={10}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <FormatAlignCenterIcon htmlColor="#F17023" />
            </InputAdornment>
          ),
        }}
        value={description}
        onChange={(e) => dispatch(setDescription(e.target.value))}
      />
    </ThemeProvider>
  );
};

export default DescriptionField;
